import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import theme from "../styles/theme";
import config from "../config";
import glamorous, { ThemeProvider } from "glamorous";
import { CookiesProvider } from "react-cookie";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";
import CookieNotice from "../components/CookieNotice";

const trimPathName = locationPathName => (
  locationPathName[locationPathName.length - 1] === "/"
    ? locationPathName.slice(0, -1)
    : locationPathName
);

const getTitle = locationPathName => config.titles[trimPathName(locationPathName)] || config.titles["/"];
const getDescription = locationPathName => config.descriptions[trimPathName(locationPathName)] || config.titles["/"];

const RootContainer = glamorous.div(({ theme }) => ({
  color: theme.main.color
}));

class TemplateWrapper extends React.PureComponent {
  constructor () {
    super();
    this.state = {
      contactFormOpen: false
    };
  }

  onToggleContactForm (event) {
    event.preventDefault();
    this.setState({
      contactFormOpen: !this.state.contactFormOpen
    });
  }

  render () {
    const { children, location } = this.props;
    const { contactFormOpen } = this.state;
    const onToggleContactForm = this.onToggleContactForm.bind(this);
    return (
      <ThemeProvider theme={theme}>
        <div>
          <Helmet
            title={getTitle(location.pathname)}
            meta={[
              { name: "description", content: getDescription(location.pathname) }
            ]}
            script={[
              {
                innerHTML: config.facebookSDKJS
              },
              {
                innerHTML: config.matomoJS
              }
            ]}
          />
          <RootContainer>
            <Header location={location} />
            <div>
              {children({ ...this.props, onToggleContactForm })}
            </div>
            <Footer />
          </RootContainer>
          <CookiesProvider>
            <CookieNotice />
          </CookiesProvider>
          <ContactForm isOpen={contactFormOpen} onToggleContactForm={onToggleContactForm} />
          <div
            dangerouslySetInnerHTML={{
              __html: config.facebookMessengerPlatformHTML
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: config.matomoNoScriptHTML
            }}
          />
        </div>
      </ThemeProvider>
    );
  }
}

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js